<ngx-spinner [fullScreen]="false"
             type="ball-clip-rotate-multiple"
             bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff"></ngx-spinner>
<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="pageTitle"></Teranet-PageTitle>
    <form [formGroup]="userProfileForm" #userProfileFormRef="ngForm" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'User Profile'" [IconName]="'user'"></Teranet-ClientTitle>
            <div *ngIf="hasError" class="alert alert-danger" role="alert">
              <div>
                <fa-icon icon="times"
                         id="errorIcon"
                         class="fa-lg"
                         matTooltipPosition="above"></fa-icon>
                &nbsp;Your data could not be saved because the following error(s) were found:
              </div>
              <div>
                <ul>
                  <li *ngFor="let errorMessage of errorMessages; let j = index">
                    {{ errorMessage }}
                  </li>
                </ul>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">First Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="firstName"
                         required
                         #firstName />
                  <mat-error *ngIf="userProfileForm.get('firstName').hasError('required') || userProfileForm.get('firstName').hasError('whitespace')">
                    {{ userErrorMessage.FIRST_NAME_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="userProfileForm.get('firstName').hasError('maxlength')">
                    {{ userErrorMessage.FIRST_NAME_MAX_LENGTH + userProfileForm.get('firstName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Middle Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="middleName"
                         #middleName />
                  <mat-error *ngIf="userProfileForm.get('middleName').hasError('whitespace')">
                    {{ userErrorMessage.MIDDLE_NAME_WHITESPACE }}
                  </mat-error>
                  <mat-error *ngIf="userProfileForm.get('middleName').hasError('maxlength')">
                    {{ userErrorMessage.MIDDLE_NAME_MAX_LENGTH + userProfileForm.get('middleName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Last Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="lastName"
                         required
                         #lastName />
                  <mat-error *ngIf="userProfileForm.get('lastName').hasError('required') || userProfileForm.get('lastName').hasError('whitespace')">
                    {{ userErrorMessage.LAST_NAME_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="userProfileForm.get('lastName').hasError('maxlength')">
                    {{ userErrorMessage.LAST_NAME_MAX_LENGTH + userProfileForm.get('lastName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label>Email</mat-label>
                <mat-form-field class="mat-form-field-md" appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="email"
                         #email />
                  <mat-error *ngIf="userProfileForm.get('email').hasError('invalidEmail')">
                    {{ emailErrorMessage.IS_NOT_EMAIL }}
                  </mat-error>
                  <mat-error *ngIf="userProfileForm.get('email').hasError('invalidDomain')">
                    {{ emailErrorMessage.EMAIL_DOMAIN }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Phone Number</mat-label>
                <mat-form-field class="mat-form-field-md" appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="phone"
                         #phone />
                  <mat-error *ngIf="userProfileForm.get('phone').hasError('invalidPhone')">
                    {{ userErrorMessage.IS_NOT_PHONE_NUMBER }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Ext.</mat-label>
                <mat-form-field class="mat-form-field-sm" appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="ext"
                         #ext />
                  <mat-error *ngIf="userProfileForm.get('ext').hasError('invalidExtension')">
                    {{ userErrorMessage.IS_NOT_PHONE_EXTENSION }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Language</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              formControlName="language"
                              placeholder="--Please Select--"
                              #language
                              [disabled]="true">
                    <mat-option *ngFor="let language of languages" [value]="language">
                      {{ language }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userProfileForm.get('language').hasError('required')">
                    {{ userErrorMessage.LANGUAGE_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Province</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              formControlName="provinceId"
                              placeholder="--Please Select--"
                              #provinceId>
                    <mat-option *ngFor="let province of provinces" [value]="province.id">
                      {{ province.description }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userProfileForm.get('provinceId').hasError('required')">
                    {{ userErrorMessage.PROVINCE_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="end center" fxFlex="100">
              <button mat-raised-button class="plain-button-lg" type="button" (click)="goBack()">Cancel</button>
              <button mat-raised-button class="theme-button-lg" type="submit" (click)="updateUserProfile()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
